import PropTypes from 'prop-types';
import React from 'react';
import FacetToken from 'brastrap/promotional/facet-token/FacetToken';
import FacetInput from './ResultsFacetsInput';

const FacetList = ({ facets, onChange }) => (
  <div className="c-results-facets--list">
    {facets.map((facet, index) => {
      const { values } = facet;
      const facetTokens = values.filter(option => option.selected);
      const displayTokens = !!facetTokens.length;
      const displayFacet = values.length > 1;

      return (
        displayFacet && (
          <details key={index} className="c-results-facet">
            <summary className="c-results-facet__header">
              <h1 className="c-results-facet__title">{facet.name}</h1>

              {displayTokens && (
                <div className="c-results-facet__tokens">
                  {facetTokens.map(option => (
                    <FacetToken
                      key={`${facet.id}-${option.id}`}
                      label={option.name}
                      onRemove={() => onChange(false, option.id, facet.id)}
                    />
                  ))}
                </div>
              )}
            </summary>

            <div className="c-results-facet__main">
              <div className="c-results-facet__items">
                {facet.values.map(option => (
                  <FacetInput
                    className="c-results-facet__item"
                    elementType="div"
                    id={`facet-input-${facet.id}-${option.id}`}
                    key={`${facet.id}-${option.id}`}
                    name={option.name}
                    count={option.count}
                    onChange={e =>
                      onChange(e.target.checked, option.id, facet.id)
                    }
                    selected={option.selected}
                    swatch={option.swatch}
                    value={option.id}
                  />
                ))}
              </div>
            </div>
          </details>
        )
      );
    })}
  </div>
);

FacetList.propTypes = {
  facets: PropTypes.array,
  onChange: PropTypes.func,
};

FacetList.defaultProps = {
  facets: [],
};

export default FacetList;
